module.exports = __webpack_public_path__ + "img/step-4.443827f0.png";